import {Directive, Input} from '@angular/core';

@Directive()
export abstract class AbstractOptionComponent {
  type: string | null = null;
  property: string | null = null;
  fullWidth = false;
  @Input() label: string | null = null;
  private onValueChangeCallback: ((property: string, value: any) => void) | null = null;

  onValueChange(callbackfn: (property: string, value: any) => void): void {
    this.onValueChangeCallback = callbackfn;
  }

  onChange(): void {
    if (this.onValueChangeCallback && this.property) {
      this.onValueChangeCallback(this.property, this.getValue());
    }
  }

  abstract setData(data: any): void;

  abstract setValue(value: any): void;

  abstract getValue(): any;
}
